import { api } from '../../lib/apiClient';

/** Public (no-login) resolution for an email-invite token — see /invite/:token. */
export async function resolveInvitationMeta(token) {
  const { data } = await api.get(`/shares/invitations/${token}`, { skipAuth: true });
  return data; // { resourceId, resourceType, name, accessMode, allowChat }
}

export async function fetchInvitationPreviewBlob(token) {
  const { data } = await api.get(`/shares/invitations/${token}/preview`, {
    skipAuth: true,
    responseType: 'blob',
  });
  return data;
}

export async function downloadInvitationFile(token, name) {
  const { data } = await api.get(`/shares/invitations/${token}/content`, {
    skipAuth: true,
    responseType: 'blob',
  });
  const url = URL.createObjectURL(data);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = name;
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
  URL.revokeObjectURL(url);
}

/** Download a file inside an invited folder — no login required. */
export async function downloadInvitationFolderFile(token, fileId, name) {
  const { data } = await api.get(`/shares/invitations/${token}/files/${fileId}/content`, {
    skipAuth: true,
    responseType: 'blob',
  });
  const url = URL.createObjectURL(data);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = name;
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
  URL.revokeObjectURL(url);
}
